import { jsx } from "react/jsx-runtime";
import { useEffect, useCallback } from "react";
import { useFocusFieldEvent } from "../../../contexts/events-context.js";
import { useTranslation } from "../../../contexts/translation-context.js";
import { TextInputWUT } from "../../../inputs/text-input-wut/text-input-wut.js";
import { SignatureFormat } from "../signature-types.js";
import { decodeDataUrl, dataUrlToWixFile, encodeDataUrl } from "../utils/data-url.js";
import styles from "./signature-text-wut.module.scss";
const SignatureTextWUT = ({
  value,
  onChange,
  inputId,
  fieldId,
  hasError,
  required,
  readOnly,
  onBlur,
  onBeforeChange,
  ariaLabel,
  ariaDescribedBy
}) => {
  const { t } = useTranslation();
  useFocusFieldEvent(() => {
    const input = document.getElementById(inputId);
    input?.focus({ preventScroll: true });
  }, fieldId);
  const decodedValue = value?.url ? decodeDataUrl(value.url) : void 0;
  const { data: signatureText = "" } = decodedValue ?? {
    data: ""
  };
  useEffect(() => {
    if (!value) {
      const input = document.getElementById(inputId);
      if (input) {
        input.value = "";
      }
    }
  }, [value, inputId]);
  const handleChange = useCallback(
    (text) => {
      onBeforeChange?.();
      if (text.trim()) {
        onChange?.(
          dataUrlToWixFile(
            encodeDataUrl({
              data: text,
              mimeType: SignatureFormat.TEXT
            })
          )
        );
      } else {
        onChange?.(null);
      }
    },
    [onBeforeChange, onChange]
  );
  return /* @__PURE__ */ jsx(
    TextInputWUT,
    {
      inputId,
      fieldId,
      type: "text",
      value: signatureText,
      onChange: handleChange,
      onBlur,
      placeholder: t("field.signature.text.placeholder"),
      hasError,
      required,
      readOnly,
      "aria-label": ariaLabel,
      ariaDescribedBy,
      className: styles.input,
      dataHook: "signature-text"
    }
  );
};
export {
  SignatureTextWUT
};
//# sourceMappingURL=signature-text-wut.js.map
